import React from "react";
import "./ProjectsComponent.css";

const testimonials = [
  { 
    name: "Running Vehicle Speed & Tire Pressure Measurement System (IoT & Azure Cloud)", 
  
    description: "Engineered a comprehensive system for real-time measurement of running vehicle speed and tire pressure. This solution enhances safety and performance monitoring for vehicles, contributing to overall road safety."
  },
  { 
    name: "IOT & AI Computation Solution for UK-based Smart Metering (Azure & Google cloud)", 
    
    description: "Implemented a sophisticated IoT and AI computation solution to enhance smart metering capabilities in the UK. Our innovative approach optimized data processing, improving efficiency and accuracy in energy consumption monitoring."
  },
  { 
    name: "Cargo Management Software for Airlines (Azure Cloud)", 
    
    description: "Developed a robust cargo management software tailored for the aviation industry. This solution streamlined logistics operations, ensuring efficient tracking, scheduling, and management of cargo for airlines."
  },
  { 
    name: "Warehouse Cargo Detection & Image Processing with Data Detection (Azure Cloud)", 
    
    description: "Introduced an advanced warehouse solution integrating RFID and IoT technologies for missing cargo detection. Implemented AI-based image processing and data detection solutions for cargo. This project aimed at improving user experience and data accuracy through innovative artificial intelligence techniques."
  },
  { 
    name: "150+ Projects Migrated from On-Premise to Cloud Platform", 
   
    description: "Successfully migrated over 150+ projects from on-premise infrastructure to cloud platforms."
  },
  { 
    name: "DevOps and DevSecOps Solution Implementation for 20+ Organizations", 
    
    description: "Our expertise in continuous integration, delivery, and security integration optimized development pipelines, ensuring faster and secure software delivery."
  },
];

const ProjectsComponents = () => {
  return (
    <div>
      {/* Yellow Background Section */}
      
      <div className="testimonials-container">
  <div style={{ textAlign: "center" }}>
    <h2 className="testimonials-heading">Our Successful Projects</h2>
  </div>
</div>

      {/* White Background Section */}
      <div className="testimonials-wrapper">
        <div className="testimonials-grid">
          {[...testimonials, ...testimonials].map((testimonial, index) => (
            <div className="testimonial-card" key={index}>
              <h3>{testimonial.name}</h3>
              <p className="role">{testimonial.role}</p>
              <p className="description">{testimonial.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProjectsComponents;
